import { createContext } from 'react';

export const DevModeContext = createContext(null);
